import { useSettings } from './useSettings';

/**
 * Вкладка детализации диалога, выбранная пользователем: заданная адресом важнее запомненной
 * за ним — указанная цель перехода не должна перекрываться привычкой.
 *
 * Ничего не выбрано — `undefined`: вкладку не выбирали ни адресом, ни прежним открытием
 * диалога, и навязывать её нечем — действует общий порядок показа вкладок.
 */
export const useSelectedDialogDataTab = (tabFromRoute?: string): string | undefined => {
  const { dialogsPage } = useSettings();

  return tabFromRoute || dialogsPage?.lastDataTab;
};
